import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "../toastService";
import "./css/Navbar.css";

import menuBar from "../assets/icons/menubar.svg";
import arrowBack from "../assets/icons/arrow_back_ios.png";

export default function Navbar({
  fixed = false,
  is_back_arrow = false,
  back_route = null,
  heading = "",
  is_step_heading = false,
  step_number = 1,
}) {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("app_language") || "en");
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
  const VERSION = process.env.REACT_APP_VERSION;

  // Listen for language changes
  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("app_language") || "en");
    };

    // Listen for storage event (works across tabs)
    window.addEventListener("storage", handleStorageChange);
    
    // Check periodically for changes in same tab (React doesn't re-render on localStorage changes)
    const interval = setInterval(() => {
      const currentLang = localStorage.getItem("app_language") || "en";
      if (currentLang !== lang) {
        setLang(currentLang);
      }
    }, 500); // Check every 500ms

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [lang]);

  // Translations
  const t = {
    en: {
      termsCondition: "Terms & Condition",
      privacyPolicy: "Privacy Policy",
      shippingPolicy: "Shipping Policy",
      refundPolicy: "Refund Policy",
      contactUs: "Contact Us",
      logOut: "Log Out",
      logoutSuccess: "Logged out successfully!",
      goBack: "Go Back",
      toggleMenu: "Toggle Menu",
    },
    ar: {
      termsCondition: "الشروط والأحكام",
      privacyPolicy: "سياسة الخصوصية",
      shippingPolicy: "سياسة الشحن",
      refundPolicy: "سياسة الاسترداد",
      contactUs: "اتصل بنا",
      logOut: "تسجيل الخروج",
      logoutSuccess: "تم تسجيل الخروج بنجاح!",
      goBack: "رجوع",
      toggleMenu: "تبديل القائمة",
    },
  }[lang];

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleLogout = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      try {
        await fetch(`${AUTH_BASE_URL}/${VERSION}/contractor/logout`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
      } catch (error) {
        console.error("Logout API failed:", error);
      }
    }

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("isAuthenticated");

    showToast(t.logoutSuccess, "error");
    navigate("/");
  };

  const handleBack = () => {
    if (back_route) {
      navigate(back_route);
    } else {
      window.history.back();
    }
  };

  return (
    <>
      {open && <div className="menu-overlay" />}

      <div
        className={`navbar-container ${fixed ? "navbar-fixed" : ""}`}
        ref={menuRef}
      >
        {/* Back button - left aligned */}
        {is_back_arrow && (
          <button
            className="back-btn-navbar"
            onClick={handleBack}
            aria-label={t.goBack}
          >
            <img src={arrowBack} alt="Back" />
          </button>
        )}

        {/* Center Heading */}
        {heading && (
          <div className="navbar-heading">
            {is_step_heading ? (
              <h2 className="step-heading">
                {heading} <span className="step-number">{step_number}</span>
              </h2>
            ) : (
              <h2 className="common-heading">{heading}</h2>
            )}
          </div>
        )}

        {/* Menu icon - right aligned */}
        <button
          className="menu-btn"
          onClick={() => setOpen((prev) => !prev)}
          aria-label={t.toggleMenu}
        >
          <img src={menuBar} alt="menu" />
        </button>

        {/* Dropdown Menu */}
        {open && (
          <div className="menu-dropdown" dir={lang === "ar" ? "rtl" : "ltr"}>
            <a
              href="https://g9eduinternational.com/terms-conditions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.termsCondition}
            </a>
            <a
              href="https://g9eduinternational.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.privacyPolicy}
            </a>
            <a
              href="https://g9eduinternational.com/shipping-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.shippingPolicy}
            </a>
            <a
              href="https://g9eduinternational.com/cancellation-refunds/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.refundPolicy}
            </a>
            <a
              href="https://g9eduinternational.com/contact/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.contactUs}
            </a>
            <button onClick={() => handleLogout()}>{t.logOut}</button>
          </div>
        )}
      </div>
    </>
  );
}